import { useState, useRef, useEffect } from "react";
import { data } from "../data/value";
import { CiMenuKebab } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { keyframes, motion } from "framer-motion";
import { AiOutlineDelete } from "react-icons/ai";
import { MdOutlineSecurityUpdateGood, MdSquareFoot } from "react-icons/md";
import { ImCross } from "react-icons/im";
import { getAllLead, getLead, getLeads, updateLead } from "../apis/leadApi";
import { getAllEnquiry } from "../apis/enquiryApi";

const Leads = () => {
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [statusOpenId, setStatusOpenId] = useState(null);
  const [items, setItems] = useState([]);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const [feedbackError, setFeedbackError] = useState(false);
  const [franchiseNameError, setFranchiseNameError] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeRowId, setActiveRowId] = useState(null);
  const [enquiries, setEnquiries] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  const [document, setDocument] = useState(null);
  const [formData, setFormData] = useState({
    status: "not yet",
    reason: "",
    followDate: "",
    feedback: "",
    franchiseName: "",
    totalAmount: "",
    initialAmount: "",
  });

  const handleMenuClick = (_id) => {
    const selectedRow = enquiries.find((item) => item._id === _id);
    setStatusOpenId(_id);
    setActiveRowId(_id);
    setFormData({
      status: selectedRow?.status || "Not Yet",
      feedback: selectedRow?.feedback || "",
    });
  };

  const handleMenu = (id) => {
    setStatusOpenId(statusOpenId === id ? null : id);
  };

  const handleStatusChange = (e) => {
    setFormData({ ...formData, status: e.target.value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Delete functionality
  const handleDelete = (id, name) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You won't be able to revert this! "${name}"`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setItems((prevItems) => prevItems.filter((item) => item.id !== id));

        Swal.fire({
          title: "Deleted!",
          text: `Your file "${name}" has been deleted.`,
          icon: "success",
        });
      }
    });
  };

  const handleSubmit = async () => {
    if (!formData?.feedback?.trim()) {
      setFeedbackError(true);
      return;
    }

    if (formData.status === "approved") {
      if (!formData?.franchiseName?.trim()) {
        setFranchiseNameError(true);
        return;
      }
      if (!formData?.totalAmount || isNaN(formData.totalAmount)) {
        alert("Total amount is required");
        return;
      }
      if (!formData?.initialAmount || isNaN(formData.initialAmount)) {
        alert("Initial amount is required");
        return;
      }
    }

    const payload = {
      status: formData.status,
      reason: formData.feedback,
      totalAmount:
        formData.status === "approved"
          ? Number(formData.totalAmount)
          : undefined,
      initialAmount:
        formData.status === "approved"
          ? Number(formData.initialAmount)
          : undefined,
      franchiseName:
        formData.status === "approved" ? formData.franchiseName : undefined,
    };

    try {
      await updateLead(statusOpenId, payload);
      setEnquiries((prev) =>
        prev.map((item) =>
          item._id === statusOpenId ? { ...item, ...payload } : item
        )
      );

      setStatusOpenId(null);
      setFeedbackError(false);
      setFranchiseNameError(false);
      setFormData({
        status: "",
        feedback: "",
        franchiseName: "",
        totalAmount: "",
        initialAmount: "",
      });
      setDocument(null);

      if (formData.status === "approved") {
        navigate("/franchise");
      }
    } catch (error) {
      console.error("Failed to update lead:", error);
    }
  };

  const handleCloseMenu = () => {
    setStatusOpenId(false);
  };

  const today = new Date().toISOString().split("T")[0];

  const openSlideshow = (photos, index) => {
    setCurrentImages(photos);
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const closeSlideshow = () => {
    setIsModalOpen(false);
  };

  const goPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? currentImages.length - 1 : prevIndex - 1
    );
  };

  const goNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === currentImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const res = await getAllLead();
        if (res.success && Array.isArray(res.data)) {
          const leads = res.data.filter((item) => item.status === "approved");
          setItems(leads);
        } else {
          setItems([]);
        }
      } catch (err) {
        console.error("Failed to fetch leads:", err);
        setItems([]);
      }
    };

    fetchLeads();
  }, []);


  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    try {
      const res = await getLeads();
      if (res.data && Array.isArray(res.data)) {
        setEnquiries(res.data);
        setItems(res.data);
      } else {
        setEnquiries([]);
        setItems([]);
      }
    } catch (err) {
      console.error(err);
      setEnquiries([]);
      setItems([]);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(items.length / itemsPerPage);

  return (
    <div>
      <h1 className="text-2xl md:text-2xl poppins-semibold mb-4 md:mb-0">
        Leads
      </h1>
      <div className="md:block hidden">
        <table className="min-w-full mt-4 bg-white border">
          <thead className="bg-red-600 whitespace-nowrap text-white">
            <tr>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                S.No
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                Name
              </th>

              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                Enquiry Date
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                Address
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                Leads Date
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                Land Size
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                Source
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                Photo
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                Status
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((item, index) => (
                <tr key={item.id || index} className="hover:bg-gray-100">
                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm cursor-pointer">
                    {index + 1}
                  </td>

                  <td className="px-2 py-4 border-b border-gray-200 text-xs cursor-pointer">
                    {item?.enquiry?.name}
                    <br />
                    {item?.enquiry?.phone}
                  </td>

                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm cursor-pointer">
                     {new Date(item.enquiry.date||"").toLocaleDateString("en-GB")}
                  </td>
                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm cursor-pointer">
                    {item.enquiry.address}
                    <p>
                      <a
                        className="exlink"
                        target="_blank"
                        href="https://maps.app.goo.gl/SjUj1YAaDicasMaQ7"
                      >
                        Location
                      </a>
                    </p>
                  </td>

                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm cursor-pointer">
                    {new Date(item.createdAt||"").toLocaleDateString("en-GB")}
                  </td>
                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm cursor-pointer">
                    {item.enquiry.landSize}
                  </td>
                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm cursor-pointer">
                    {item.enquiry.source}
                  </td>
                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm ">
                    {item.medias?.length > 0 && (
                      <p>
                        <span
                          className="exlink"
                          target="_blank"
                          onClick={(e) => {
                            openSlideshow(item.photos, 0);
                          }}
                        >
                          Media
                        </span>
                      </p>
                    )}
                  </td>

                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm cursor-pointer">
                    <span
                      className={`font-bold ${
                        item.status === "approved"
                          ? "text-green-600"
                          : item.status === "rejected"
                          ? "text-red-600"
                          : item.status === "followup"
                          ? "text-blue-600"
                          : "text-gray-600"
                      }`}
                    >
                      {item.status || "Not Yet"}
                    </span>

                    {item.status === "rejected" && (
                      <p className="text-xs text-red-600 mt-1">
                        Reason: {item.reason || "No reason provided"}
                      </p>
                    )}

                    {item.status === "followup" && (
                      <p className="text-xs text-blue-600 mt-1">
                        Follow-up required
                      </p>
                    )}
                  </td>

                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm">
                    <button
                      onClick={() => handleMenuClick(item._id)}
                      className="p-2"
                    >
                      <CiMenuKebab className="font-bold" fontSize={20} />
                    </button>

                    {menuOpenId === item._id && (
                      <motion.div
                        ref={menuRef}
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="absolute right-0 mt-2 w-32 p-3 bg-white border border-gray-300 rounded-lg shadow-xl"
                      >
                        <div className="space-y-3">
                          <div className="flex gap-3 relative">
                            <AiOutlineDelete className="rounded-md text-[#fd0002] font-bold" />
                            <button
                              className="rounded-md text-[#fd0002] font-medium absolute -top-1 left-7"
                              onClick={() => handleDelete(item._id, item.name)}
                            >
                              Delete
                            </button>
                          </div>
                          <div className="flex gap-3 relative">
                            <MdOutlineSecurityUpdateGood className="text-green-600 font-bold" />
                            <button
                              className="rounded-md text-green-600 font-poppins font-medium absolute -top-1 left-7"
                              onClick={() => handleMenu(item._id)}
                            >
                              Status
                            </button>
                          </div>
                        </div>
                      </motion.div>
                    )}
                    <div>
                      <>
                        {statusOpenId === item._id && (
                          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
                            <div className="w-[400px] bg-white border rounded-lg shadow-xl px-5 py-6 h-96 overflow-y-auto">
                              <div className="flex justify-end">
                                <button
                                  onClick={handleCloseMenu}
                                  className="text-red-600 transition duration-200 font-bold p-2 hover:text-red-800"
                                >
                                  <ImCross />
                                </button>
                              </div>

                              <div className=" flex justify-between bg-gray-100 p-3 rounded-md">
                                <div className="">
                                  <p className="text-sm font-medium text-gray-700">
                                    {item.enquiry.name}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                    {item.enquiry.phone}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                    {item.enquiry.email}
                                  </p>
                                </div>
                              </div>

                              <div className="mt-4">
                                <h2 className="text-lg font-bold text-black ">
                                  Update Status
                                </h2>
                              </div>

                              <div className="flex justify-between gap-4 mt-4">
                                <label className="flex items-center gap-2">
                                  <input
                                    type="radio"
                                    name="status"
                                    value="approved"
                                    checked={formData.status === "approved"}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        status: e.target.value,
                                      })
                                    }
                                  />
                                  <span className="text-green-600 font-semibold">
                                    Approved
                                  </span>
                                </label>

                                <label className="flex items-center gap-2">
                                  <input
                                    type="radio"
                                    name="status"
                                    value="followup"
                                    checked={formData.status === "followup"}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        status: e.target.value,
                                      })
                                    }
                                  />
                                  <span className="text-blue-600 font-semibold">
                                    Follow Up
                                  </span>
                                </label>

                                <label className="flex items-center gap-2">
                                  <input
                                    type="radio"
                                    name="status"
                                    value="rejected"
                                    checked={formData.status === "rejected"}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        status: e.target.value,
                                      })
                                    }
                                  />
                                  <span className="text-red-600 font-semibold">
                                    Rejected
                                  </span>
                                </label>
                              </div>

                              <div className="mt-5">
                                <textarea
                                  type="text"
                                  placeholder="Enter feedback"
                                  value={formData.feedback}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      feedback: e.target.value,
                                    })
                                  }
                                  className="w-full border border-gray-300 p-3 rounded-md text-sm focus:ring-red-500 focus:border-red-500 outline-none"
                                />
                                {feedbackError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    Feedback is required.
                                  </p>
                                )}
                                {formData.status === "approved" && (
                                  <>
                                    <div className="mt-3">
                                      <label className="font-medium text-sm block mb-1">
                                        Document:
                                      </label>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) =>
                                          setDocument(e.target.files[0])
                                        }
                                        className="w-full px-2 py-2 border rounded-md text-sm"
                                      />
                                    </div>

                                    <div className="w-full mt-3">
                                      <label className="text-sm font-medium block mb-1">
                                        Total Amount
                                      </label>
                                      <input
                                        type="text"
                                        name="totalAmount"
                                        placeholder="Enter Total Amount"
                                        value={formData.totalAmount}
                                        onChange={handleChange}
                                        className="outline-none px-3 py-2 border border-gray-300 rounded-md w-full"
                                      />
                                    </div>

                                    <div className="w-full mt-3">
                                      <label className="text-sm font-medium block mb-1">
                                        Initialize Amount
                                      </label>
                                      <input
                                        type="text"
                                        name="initialAmount"
                                        placeholder="Enter Initialize Amount"
                                        value={formData.initialAmount}
                                        onChange={handleChange}
                                        className="outline-none px-3 py-2 border border-gray-300 rounded-md w-full"
                                      />
                                    </div>

                                    <div className="w-full mt-3">
                                      <label className="text-sm font-medium block mb-1">
                                        Franchise Name
                                      </label>
                                      <input
                                        type="text"
                                        name="franchiseName"
                                        placeholder="Enter Franchise Name"
                                        value={formData.franchiseName}
                                        onChange={handleChange}
                                        className="outline-none px-3 py-2 border border-gray-300 rounded-md w-full"
                                      />
                                      {franchiseNameError && (
                                        <p className="text-red-600 text-xs mt-1">
                                          Franchise name is required.
                                        </p>
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>

                              <div className="w-full mt-6">
                                <button
                                  className="rounded-md px-4 py-2 text-center border border-gray-300 bg-red-600 text-white font-medium w-full hover:bg-red-700 transition"
                                  onClick={handleSubmit}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    </div>
                  </td>
                  <>
                    {isModalOpen && currentImages.length > 0 && (
                      <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-25 z-50">
                        <div className="relative bg-white p-4 rounded-lg shadow-lg w-[450px] h-auto flex flex-col items-center">
                          <button
                            className="absolute top-2 right-2 text-red-600 text-xl font-bold"
                            onClick={closeSlideshow}
                          >
                            <ImCross size={20} />
                          </button>

                          <div className="flex justify-center mt-8">
                            <img
                              src={currentImages[currentIndex]}
                              alt="Slideshow"
                              className="w-[300px] h-[300px] rounded-lg object-cover"
                            />
                          </div>

                          <div className="flex justify-between w-full px-6 mt-4">
                            <button
                              className="bg-gray-800 text-white px-4 py-2 rounded-md"
                              onClick={goPrev}
                            >
                              ◀ Previous
                            </button>
                            <button
                              className="bg-gray-800 text-white px-4 py-2 rounded-md"
                              onClick={goNext}
                            >
                              Next ▶
                            </button>
                          </div>

                          <p className="text-center text-sm text-gray-600 mt-2">
                            {currentIndex + 1} / {currentImages.length}
                          </p>

                          {Array.isArray(currentImages) &&
                            currentImages.length > 0 && (
                              <div className="mt-4 flex flex-wrap gap-2 justify-center">
                                {currentImages.map((preview, index) => (
                                  <img
                                    key={index}
                                    src={preview}
                                    alt={`Preview ${index}`}
                                    className={`w-16 h-16 object-cover rounded-md border cursor-pointer 
                                ${
                                  index === currentIndex
                                    ? "border-4 border-blue-500"
                                    : "border-gray-300"
                                }`}
                                    onClick={() => setCurrentIndex(index)}
                                  />
                                ))}
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                  </>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-gray-500">
                  No enquiries found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center mt-4 space-x-2">
        <button
          className="px-3 py-1 border rounded disabled:opacity-50"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`px-3 py-1 border rounded ${
              currentPage === i + 1 ? "bg-red-600 text-white" : ""
            }`}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className="px-3 py-1 border rounded disabled:opacity-50"
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Leads;
